import { render } from "./EmployeeLocationWidget.vue?vue&type=template&id=9d9d3d76&scoped=true"
import script from "./EmployeeLocationWidget.vue?vue&type=script&lang=js"
export * from "./EmployeeLocationWidget.vue?vue&type=script&lang=js"

import "./EmployeeLocationWidget.vue?vue&type=style&index=0&id=9d9d3d76&lang=scss&scoped=true"

import exportComponent from "/var/webapps/orangehrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d9d3d76"]])

export default __exports__